import React from 'react';
import { Link } from 'react-router';
import { Button, TableBody, TableCell, TableRow } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IOrder } from 'pages/orderHistory/hooks/useOrders';
import { useOrdersTableBody } from 'pages/orderHistory/hooks/useOrdersTableBody';

import { useStyles } from './styles';

interface IOrdersTableBodyProps {
  orders: IOrder[];
}

export const OrdersTableBody = ({ orders }: IOrdersTableBodyProps) => {
  const classes = useStyles();

  const { order_params, shouldHideColumn } = useOrdersTableBody();

  const faPropIcon = faEye as IconProp;

  return (
    <TableBody>
      {orders.map((order, i) => (
        <TableRow key={i}>
          <TableCell className={classes.tableRowCell} component="th" scope="row">
            <Link to={`historico-de-agendamento/detalhes/${order_params(order)}`}>
              <Button className={classes.buttonDetail}>
                <FontAwesomeIcon icon={faPropIcon} size="2x" />
              </Button>
            </Link>
          </TableCell>

          {/* eslint-disable-next-line */}
          {Object.entries(order).map(([key, value]) =>
            shouldHideColumn(key) ? null : (
              <TableCell key={key} className={classes.tableRowCell} component="th" scope="row">
                {value}
              </TableCell>
            )
          )}
        </TableRow>
      ))}
    </TableBody>
  );
};
